import { render, staticRenderFns } from "./editNaturalSpellingPage.vue?vue&type=template&id=52721e10&"
import script from "./editNaturalSpellingPage.vue?vue&type=script&lang=js&"
export * from "./editNaturalSpellingPage.vue?vue&type=script&lang=js&"
import style0 from "./editNaturalSpellingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports